import APIClient from './index';
import _ from 'lodash';

// Floors
export const getOfficeFloors = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeFloors')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createOfficeFloor = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('OfficeFloors', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateOfficeFloor = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`OfficeFloors/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getOfficeFloorZoomParticipants = id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`OfficeFloors/${id}/zoom-participants`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Spaces
export const getOfficeSpaces = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeSpaces', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getOfficeSpace = id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`OfficeSpaces/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createOfficeSpace = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('OfficeSpaces', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateOfficeSpace = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`OfficeSpaces/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const deleteOfficeSpace = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`OfficeSpaces/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Availability
export const getOfficeSpaceAvailability = params => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeSpaces/availability', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Bookings
export const createOfficeBooking = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('OfficeBookings', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateOfficeBooking = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`OfficeBookings/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const shuffleDeskBookings = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`OfficeBookings/shuffle`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const deleteOfficeBooking = (id, deleteMeeting = false) => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`OfficeBookings/${id}?deleteMeeting=${deleteMeeting}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getMyOfficeBookings = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeBookings/mine')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getOfficeBookingsMeetings = params => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeBookings/meetings', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getOfficeTeamMembers = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeBookings/team')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getOfficeRoster = date => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeBookings/roster', { params: { date } })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getUserOfficeSchedule = (userId, starts_at, ends_at) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`OfficeBookings/user/${userId}/schedule`, { params: { starts_at, ends_at } })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Announcements
export const getOfficeAnnouncements = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('OfficeAnnouncements', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createOfficeAnnouncement = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('OfficeAnnouncements', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateOfficeAnnouncement = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`OfficeAnnouncements/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const deleteOfficeAnnouncement = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`OfficeAnnouncements/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
